<template>
  <header>
    <modal class="release-modal" ref="releaseModal">
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('header.whats_new') }}</h5>
      </template>
      <template #body>
        <div class="modal-body">
          <ul>
            <li v-for="release in releaseNotes">
              <span>{{ formatDate(release.published) }}</span>
              <a :href='release.link' target="_blank">{{release.title}}</a>
              <p v-text="release.summary"></p>
              <a :href='release.link' class="learn" target="_blank">{{$t('header.learn_more')}}</a>
            </li>
          </ul>
        </div>
      </template>
    </modal>

    <send-message-modal ref='sendMessageModal'/>
    <recommend-relatico ref="recommendRelatico" />

    <form @submit.prevent='goToSearchPage()' class="search-container">
      <input
        :class="['search-bar', 'ui-autocomplete-input', { active: bigSearch }]"
        :placeholder="$t('header.search')"
        @click="bigSearch = true"
        @input="debounceSearch"
        autocomplete="off"
        id="topbar-search"
        name="q"
        required="required"
        type="text"
        v-click-outside="closeSearch"
        v-model="inputSearch">
      <button type="submit">
        <i class="fas fa-search"></i>
      </button>
    </form>
    <ul class="short-search-results" v-if="showSearch">
      <li :key='result._id' @click.prevent="goToPage(result)" v-for="result in searchData">
        <img :alt="iconType(result._source).alt" :src="iconType(result._source).src">
        <strong v-if="result.highlight && result.highlight.content.length !== 0" v-html="result.highlight.content[0]"></strong>
        <strong v-else>{{result._source.content || result._source.source_type}} </strong>
      <li @click.prevent="goToSearchPage" class="see-all">
        <p>{{ $t('header.see_all_data') }} ({{ searchDataMeta.total }})</p>
      </li>
    </ul>

    <div @click.prevent='$refs.sendMessageModal.open' class="btn btn-primary float-right" href='#'>
      {{ $t('header.send_message') }}
    </div>

    <div class="help-questions">
      <i @click.prevent="showTipBox = !showTipBox" class="far fa-question-circle"></i>
      <div class="help-tips" v-if="showTipBox">
        <button @click.prevent="showTipBox = false" aria-label="Close" class="close" data-dismiss="modal" type="button">
          <span aria-hidden="true">×</span>
        </button>
        <div class="onboarding-checklist" v-if="!noDataUser && hasNothing && $route.name === 'home'">
          <h1 v-if="!hasNothing">{{ $t('onboarding.no_data_title') }} {{ this.currentUser.full_name}}!</h1>
          <h2 v-if="!hasNothing">{{ $t('onboarding.no_data_sentence') }}</h2>
          <h1 v-if="step2">{{ $t('onboarding.files_uploaded_title') }} {{ this.currentUser.full_name}}!</h1>
          <h2 v-if="step2">{{ $t('onboarding.files_uploaded_sentence') }}</h2>
          <h1 v-if="step3">{{ $t('onboarding.one_step_left_title') }} {{ this.currentUser.full_name}}!</h1>
          <h2 v-if="step3">{{ $t('onboarding.one_step_left_sentence') }}</h2>

          <ul>
            <li v-if="comingFromRegistration" :class="{ 'crossed': this.currentUser.has_files}">
              <label class="checkbox-container disabled">
                <input :checked="this.currentUser.has_files" name="user[has_files]" type="checkbox">
                <span class="checkmark"></span>
              </label>
              <h3><a href="/folders#upload">{{ $t('onboarding.step1_title') }}</a></h3>
              <p><span>{{ $t('onboarding.step1_sentence') }}</span>
                <a href="/folders">{{ $t('onboarding.step1_link') }}</a>
                <span>{{ $t('onboarding.step1_sentence2') }}</span></p>
            </li>
            <li v-else :class="{ 'crossed': this.currentUser.has_files}">
              <label class="checkbox-container disabled">
                <input type="checkbox" name="user[has_files]" :checked="this.currentUser.has_files">
                <span class="checkmark"></span>
              </label>
              <h3>{{ $t('onboarding.step1_title') }}</h3>
              <p><span>{{ $t('onboarding.step1_sentence') }}</span>
                <a href="/folders">{{ $t('onboarding.step1_link') }}</a>
                <span>{{ $t('onboarding.step1_sentence2') }}</span></p>
            </li>
            <li v-if="comingFromRegistration" :class="{ 'crossed': this.currentUser.has_folders}">
              <label class="checkbox-container disabled">
                <input :checked="this.currentUser.has_folders" name="user[has_folders]" type="checkbox">
                <span class="checkmark"></span>
              </label>
              <h3><a href="/folders#folder">{{ $t('onboarding.step2_title') }}</a></h3>
              <p><span>{{ $t('onboarding.step2_sentence') }}</span>
                <a href="/folders">{{ $t('onboarding.step1_link') }}</a>
                <span>{{ $t('onboarding.step2_sentence2') }}</span>
              </p>
            </li>
            <li v-else :class="{ 'crossed': this.currentUser.has_folders}">
              <label class="checkbox-container disabled">
                <input type="checkbox" name="user[has_folders]" :checked="this.currentUser.has_folders">
                <span class="checkmark"></span>
              </label>
              <h3>{{ $t('onboarding.public_upload.step2_title') }}</h3>
              <p><span>{{ $t('onboarding.step2_sentence') }}</span>
                <a href="/folders">{{ $t('onboarding.step1_link') }}</a>
                <span>{{ $t('onboarding.step2_sentence2') }}</span>
              </p>
            </li>
            <li v-if="comingFromRegistration" :class="{ 'crossed': this.currentUser.has_checklist}">
              <label class="checkbox-container disabled">
                <input :checked="this.currentUser.has_checklist" name="user[has_checklist]" type="checkbox">
                <span class="checkmark"></span>
              </label>
              <h3>{{ $t('onboarding.step3_title') }}</h3>
              <p><span>{{ $t('onboarding.step3_sentence') }}</span></p>
            </li>
            <li v-else :class="{ 'crossed': this.currentUser.has_checklist}">
              <label class="checkbox-container disabled">
                <input type="checkbox" name="user[has_checklist]" :checked="this.currentUser.has_checklist">
                <span class="checkmark"></span>
              </label>
              <h3>{{ $t('onboarding.public_upload.step3_title') }}</h3>
              <p><span>{{ $t('onboarding.public_upload.step3_sentence') }}</span></p>
            </li>
          </ul>
          <a :href='helpCenterUrl' target="false">{{ $t('header.go_to_help_center')}}</a>
          <a :href='helpCenterUrl' @click.prevent="openReleaseModal" target="false">{{ $t('header.whats_new') }}</a>
        </div>
        <div v-else-if="$route.name === 'home' && !hasNothing">
          <p class="text-center">{{ $t('tips.has_nothing') }}</p>
          <a :href='helpCenterUrl' target="false">{{ $t('header.go_to_help_center')}}</a>
          <a :href='helpCenterUrl' @click.prevent="openReleaseModal" target="false">{{ $t('header.whats_new') }}</a>
        </div>
        <div v-else>
          <p>{{ $t(`tips.${$route.name}`) }}</p>
          <a :href='helpCenterUrl' target="false">{{ $t('header.go_to_help_center')}}</a>
          <a :href='helpCenterUrl' @click.prevent="openReleaseModal" target="false">{{ $t('header.whats_new') }}</a>
        </div>
      </div>
    </div>

    <nav class="navbar-custom">
      <ul class="list-inline">
        <li class="list-inline-item dropdown notification-list">
          <a @click.prevent='showUnseenNotifications' class="nav-link dropdown-toggle arrow-none" href="#">
            <i class="far fa-bell noti-icon"></i>
            <span class="badge noti-icon-badge" v-if="unseenNotificationsCount">
              {{unseenNotificationsCount}}
            </span>
          </a>

          <div :class="['dropdown-menu', 'dropdown-menu-right', 'dropdown-arrow', 'dropdown-menu-lg', 'notification-dropdown', { show: showUnseen }]" v-click-outside='hideNotifications'
               v-if='showUnseen'>
            <div class="dropdown-item noti-title">
              <h5>{{ $t('header.notifications') }} ({{ unseenNotificationsCount }})</h5>
            </div>

            <div class="empty-list-wrapper" v-if="unseenNotificationsCount === 0">
              <img src="../assets/empty_states/notifications.png">
              <p>{{ $t('header.no_notifications') }}</p>
            </div>
            <div v-else>
              <ul>
                <li :key='notification.id' v-for="notification in unseenNotifications.slice(0, 6)">
                  <a @click.prevent='goToNotification(notification)' class="dropdown-item notify-item" href='#'>
                    <div class="notify-icon bg-primary">
                      <i class="fas fa-sticky-note"></i>
                    </div>

                    <p class="notify-details">
                      <small class="text-muted">
                        {{notification.body}}
                      </small>
                    </p>
                  </a>
                </li>
              </ul>
            </div>

            <router-link :to="{ name: 'notifications' }" @click.native='hideNotifications()'
                         class="notify-item link-next">
              {{ $t('header.view_all') }}
            </router-link>
            <a @click.prevent="markAllNotificationsRead" class="notify-item link-next" href='#'
               v-if="unseenNotificationsCount > 0">{{ $t('notifications.mark_read') }}</a>
          </div>
        </li>

        <li class="list-inline-item dropdown user-info">
          <a aria-expanded="false" aria-haspopup="false" class="nav-link dropdown-toggle arrow-none nav-user" data-toggle="dropdown" href="#"
             role="button">
            <user-image :user='currentUser'/>

            <span class="user-name-wrapper" v-if="currentUser">
             {{ currentUser.full_name }}
            </span>
            <i class="fas fa-arrow-down"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right profile-dropdown">
            <router-link :to="{name: 'account_settings'}" class="dropdown-item">
              <i class="fas fa-cog text-muted"></i>
              {{ $t('header.account_settings') }}
            </router-link>
            <a @click.prevent='$refs.recommendRelatico.open' class="dropdown-item" href="#">
              <img src="../assets/recommend-icon.svg" />
              {{ $t('header.recommend') }}
            </a>
            <a @click.prevent='logout' class="dropdown-item" href="#">
              <i class="fas fa-sign-out-alt text-muted"></i>
              {{ $t('header.logout') }}
            </a>
          </div>
        </li>
      </ul>
      <ul class="list-inline menu-left mb-0">
        <li class="list-inline-item">
          <button class="button-menu-mobile open-left" type="button">
            <i class="ion-navicon"></i>
          </button>
        </li>
      </ul>
    </nav>
    <a :href="outlookLink()" target="_blank" class="outlook-add" >
      <img src="../assets/relatico_favicon.png" />
        {{ $t('header.outlook_addin') }}
    </a>
  </header>
</template>

<script>
import _modal from './_modal'
import _send_message_modal from './_send_message_modal'
import _user_image from './_user_image'
import _recommend_relatico from './_recommend'

export default {
  components: {
    'modal': _modal,
    'user-image': _user_image,
    'send-message-modal': _send_message_modal,
    'recommend-relatico': _recommend_relatico
  },
  created() {
    this.store.getUnseenNotificationsCount()
  },
  data() {
    return {
      inputSearch: null,
      showSearch: false,
      bigSearch: false,
      showUnseen: false,
      showTipBox: false,
      debounce: null,
      searchTerm: '',
      result: [],
      resultCounts: 0
    }
  },
  name: "Header",
  computed: {

    notifications() {
      return this.state.notifications || []
    },
    unseenNotifications() {
      return this.notifications.filter(({seen}) => !seen) || []
    },
    unseenNotificationsCount() {
      return this.state.unseenNotificationsCount || 0
    },
    searchData() {
      return this.result || []
    },
    searchDataMeta() {
      return { total: this.resultCounts, params: this.inputSearch }
    },
    helpCenterUrl() {
      return this.locale === 'de' ? 'https://support.relatico.com/de/' : 'https://support.relatico.com/en/'
    },
    releaseNotes() {
      return this.state.releaseNotes || {}
    },
    noDataUser() {
      return this.currentUser.has_files && this.currentUser.has_checklist && this.currentUser.has_folders
    },
    hasNothing() {
      return this.currentUser.has_files || this.currentUser.has_checklist || this.currentUser.has_folders
    },
    step2() {
      return this.currentUser.has_files && !this.currentUser.has_checklist && !this.currentUser.has_folders
    },
    step3() {
      return this.currentUser.has_files && !this.currentUser.has_checklist && this.currentUser.has_folders
    },
    comingFromRegistration(){
      return this.currentUser.coming_from === "registration"
    },
  },
  methods: {
    debounceSearch() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        if (this.inputSearch.length >= 3) {
          const all_indices = this.axios.get('searches', { params: {q: this.inputSearch, size: 10} })
          const shared_folders = this.axios.get('searches', { params: {q: this.inputSearch, size: 10, source_type: 'shared_folders'} })
          const shared_records = this.axios.get('searches', { params: {q: this.inputSearch, size: 10, source_type: 'shared_records'} })

          this.result = []
          this.resultCounts = 0

          Promise.allSettled([all_indices, shared_records, shared_folders]).then((data) => {
            if(data){
              this.populateResult(data[0])
              this.populateResult(data[1])
              this.populateResult(data[2])
            }
          })
          this.showSearch = true
        }
      }, 150)
    },
    populateResult(promiseData){
      if(promiseData.status === 'fulfilled'){
        let result = promiseData.value.data.result
        let counts = promiseData.value.data.meta.total
        for (var i=0; i < result.length; i++){
          if(this.result.length === 10)
            break
          this.result.push(result[i])
        }
        this.resultCounts += counts
      }
    },
    goToNotification(notification) {
      this.store.updateNotification(notification.id, {seen: true}).then(() => {
        this.showUnseen = false
        if(notification.link)
          window.open(notification.link, '_blank')
        else
          this.$router.push(notification.router_params)

        this.store.getUnseenNotificationsCount()
      })
    },
    hideNotifications() {
      this.showUnseen = false
    },
    showUnseenNotifications() {
      if (this.showUnseen)
        return this.hideNotifications()

      this.store.getNotifications().then(() => this.showUnseen = true)
    },
    logout() {
      this.store.logout().then(() => {
        this.store.sendMetrics({name: 'logout', params: this.$route.params, path: this.$route.fullPath})
        this.$router.push({name: 'login'})
      })
    },
    closeSearch() {
      this.showSearch = false
      this.bigSearch = false
    },
    goToSearchPage() {
      if (this.inputSearch.length > 2) {
        this.showSearch = false
        this.$router.push({name: 'search_results', query: {q: this.inputSearch, index: null}})
      }
    },
    goToPage(result) {
      this.store.sendMetrics({name: 'detail_page_from_search', params: this.$route.params, path: this.$route.fullPath})
      if (result._source.source_type === 'Tag') {
        this.$router.push({name: "tag", params: {id: result._source.source_id}})
      } else if (result._source.source_type === 'Product') {
        this.$router.push({name: "product", params: {id: result._source.source_id}})
      } else if (result._source.source_type === 'DocumentType') {
        this.$router.push({name: "document_type", params: {id: result._source.source_id}})
      } else if (result._source.source_type === 'Folder') {
        this.$router.push({name: "folder", params: {id: result._source.source_id}})
      } else if (result._source.source_type === 'Record') {
        this.$router.push({name: "record", params: {id: result._source.source_id}})
      } else if (result._source.source_type === 'Contact') {
        this.$router.push({name: 'contact_folders', params: {id: result._source.source_id}})
      } else if (result._source.source_type === 'DocumentRequest') {
        this.$router.push({name: 'message', params: {id: result._source.source_id, messageType: 'sent'}})
      } else if (result._source.source_type === 'DocumentResponse') {
        this.$router.push({name: 'message', params: {id: result._source.source_id, messageType: 'inbox'}})
      } else if (result._source.source_type === 'SharedFolder') {
        this.$router.push({name: "shared_folder_show", params: {id: result._source.source_id}})
      } else if (result._source.source_type === 'SharedRecord') {
        this.$router.push({name: "shared_record_show", params: {id: result._source.source_id}})
      }
    },
    openReleaseModal() {
      this.store.getReleaseNotes().then(() => this.$refs.releaseModal.open())
    },
    markAllNotificationsRead() {
      this.showUnseen = false
      this.$toastr.success(this.$t('notifications.updating'))
      this.store.markAllNotificationsSeen().then(({data}) => {
        this.store.getNotifications()
        this.store.getUnseenNotificationsCount()

        let message = this.$t('notifications.mark_as_all_read', {notifications: data.success})
        if (data.failures > 0)
          message += this.$t('notifications.but', {notificationsFailed: data.failures})

        this.$toastr.success(message)
      })
    },
    outlookLink(){
      if(this.locale === 'de')
        return 'https://appsource.microsoft.com/de-de/product/office/WA200003057'
      return 'https://appsource.microsoft.com/en-us/product/office/WA200003057'
    }
  },
}
</script>

<style lang="sass" scoped>
@import "../styles/header"
.link-next
  float: left

.folder-label
  display: block

.release-modal
  ul
    margin: 0
    padding: 0
    list-style: none
    height: 600px
    overflow: auto

    li
      padding-bottom: 15px

      span
        font-size: 16px
        color: #828282
        display: block
        padding-bottom: 10px

      a
        font-size: 16px
        color: #6A94FF
        margin-bottom: 10px
        display: block
        font-weight: 500

      p
        font-size: 16px
        line-height: 22px
        margin-bottom: 0

      a.learn
        font-weight: 400
</style>
